import React from "react";

const AffiliationPage = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center bg-gray-100">
      <h1 className="text-3xl font-semibold text-gray-700">
        Coming Soon...
      </h1>
    </div>
  );
};

export default AffiliationPage;